/* Shared fee policy. Shopify, not this script, determines discount eligibility. */
(function (root) {
  'use strict';
  const policy = {
    required(series, printing, artwork) {
      return printing === 'Yes' && artwork === 'upload';
    },
    append(form, options) {
      if (!this.required(options.series, options.printing, options.artwork)) return;
      if (!options.variantId) throw new Error('Plate setup is temporarily unavailable. Please contact us before ordering.');
      form.append('items[1][id]', String(options.variantId));
      form.append('items[1][quantity]', '1');
      form.append('items[1][properties][For Product]', options.productTitle);
      form.append('items[1][properties][Series]', options.series === 'immortal' ? 'Immortal' : 'Rehearsal');
      form.append('items[1][properties][Artwork]', options.artwork === 'upload' ? 'New or changed artwork' : 'Use artwork on file');
      form.append('items[1][properties][_plate_group]', options.group);
      form.append('items[0][properties][_plate_group]', options.group);
      form.append('items[0][properties][Plate setup]', 'Added as a separate line item');
      if (options.filename) form.append('items[1][properties][Artwork filename]', options.filename);
    }
  };
  if (typeof module === 'object' && module.exports) module.exports = policy;
  else root.SignaturePlateSetup = policy;
})(typeof window === 'object' ? window : this);
